import { render, staticRenderFns } from "./BodyAddElementMenu.vue?vue&type=template&id=bec801f8&"
import script from "./BodyAddElementMenu.vue?vue&type=script&lang=js&"
export * from "./BodyAddElementMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports